import { render, staticRenderFns } from "./QuoteView.vue?vue&type=template&id=5a44faac&scoped=true"
import script from "./QuoteView.vue?vue&type=script&lang=js"
export * from "./QuoteView.vue?vue&type=script&lang=js"
import style0 from "./QuoteView.vue?vue&type=style&index=0&id=5a44faac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44faac",
  null
  
)

export default component.exports